rs.module("jobs/memberstatementbatches/index",

    ["controls/data/grid"],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, ajaxUrl) {

            var filter = $.js(jsSelectors.filter);
            var batchTypeRadioList = filter.js(jsSelectors.batchTypeRadioList);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Hook up select event on the selectorto reload the grid data via ajax
            batchTypeRadioList.change(function () {
                loadingSpinner.show();

                gridModule.update(
                    ajaxUrl,
                    { batchType: batchTypeRadioList.find('input:checked').val() },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);